import jerseyLogo from "@/assets/logo-jersey.jpeg";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

let logoPromise;

export function loadOfficialLogo() {
  if (!logoPromise) {
    logoPromise = new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = reject;
      image.src = jerseyLogo;
    });
  }
  return logoPromise;
}

export function drawOfficialHeader(doc, { logo, title, details = [], unofficial = false }) {
  const width = doc.internal.pageSize.getWidth();
  const height = doc.internal.pageSize.getHeight();
  doc.addImage(logo, "JPEG", 26, 17, 42, 40);
  doc.setTextColor(21, 11, 50);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Associação dos Criadores de Gado Jersey do Brasil", width / 2, 27, { align: "center" });
  doc.setFontSize(8);
  doc.text("PROGRAMA NACIONAL DE MELHORAMENTO DO GADO JERSEY", width / 2, 41, { align: "center" });
  doc.text("MINISTÉRIO DA AGRICULTURA, PECUÁRIA E ABASTECIMENTO - MAPA", width / 2, 51, { align: "center" });
  doc.text("EMBRAPA GADO DE LEITE", width / 2, 61, { align: "center" });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.text("Registrado no MAPA sob o n° BR-02", width - 26, 73, { align: "right" });
  doc.setDrawColor(185, 139, 27);
  doc.line(26, 79, width - 26, 79);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(title, width / 2, 96, { align: "center" });
  if (unofficial) {
    doc.setFillColor(255, 235, 229);
    doc.roundedRect(width - 140, 84, 114, 17, 3, 3, "F");
    doc.setTextColor(160, 45, 35);
    doc.setFontSize(8);
    doc.text("NÃO OFICIAL", width - 83, 95, { align: "center" });
  }
  doc.setTextColor(35, 37, 48);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  details.forEach((line, index) => doc.text(line, 26, 110 + index * 10));
  doc.setDrawColor(220, 224, 230);
  doc.line(26, 139, width - 26, 139);
  doc.setFontSize(7);
  doc.setTextColor(110, 115, 125);
  doc.text(`Página ${doc.internal.getCurrentPageInfo().pageNumber}`, width - 26, height - 16, { align: "right" });
}

export async function exportOfficialTablePdf({ table, title, details = [], filename, print = false }) {
  const printWindow = print ? window.open("", "_blank") : null;
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  const logo = await loadOfficialLogo();
  const pdfTable = document.querySelector(table).cloneNode(true);
  const actionColumns = [...pdfTable.querySelectorAll("thead th")]
    .map((header, index) => !header.textContent.trim() &&
      [...pdfTable.querySelectorAll("tbody tr")].some(row => row.cells[index]?.querySelector("button")) ? index : -1)
    .filter(index => index >= 0);
  actionColumns.reverse().forEach(index =>
    pdfTable.querySelectorAll("tr").forEach(row => row.cells[index]?.remove())
  );
  doc.autoTable({
    html: pdfTable,
    startY: 151,
    margin: { left: 26, right: 26, top: 151, bottom: 30 },
    theme: "grid",
    styles: { font: "helvetica", fontSize: 7, cellPadding: 3, textColor: [35, 37, 48], overflow: "linebreak" },
    headStyles: { fillColor: [21, 11, 50], textColor: 255, fontStyle: "bold" },
    didDrawPage: () => drawOfficialHeader(doc, { logo, title, details })
  });
  if (print) {
    doc.autoPrint();
    if (printWindow) printWindow.location.href = doc.output("bloburl");
    else doc.save(filename);
  } else {
    doc.save(filename);
  }
}
